export const PROFILE_STEP: 'profileStep' = 'profileStep'
export const PROFILE_CYCLE: 'profileCycle' = 'profileCycle'
